import React from "react";
import { m as motion } from "../../shared/components/Motion";
import "./styles/CustomThemeForm.css";
import { ButtonComponent } from "shared/components";
import { accordionContainer, accordionItem } from "shared/utils";

function CustomThemeForm({
  colorProperties,
  colors,
  handleColorChange,
  handleSubmit,
  handleFormVisibility,
}) {
  return (
    <>
      {colorProperties.map((property, index) => (
        <motion.div
          className="themes__form-group"
          key={index}
          variants={accordionContainer}
          initial="hidden"
          animate="visible"
          exit="exit"
        >
          <label className="themes__model-title">{property.label}</label>
          <input
            className="themes__form-input"
            type="color"
            name={property.name}
            value={colors[property.name]}
            onChange={handleColorChange}
            autoComplete="color"
          />
        </motion.div>
      ))}
      <motion.div
        variants={accordionItem}
        initial="hidden"
        animate="visible"
        exit="exit"
        transition={{ delay: colorProperties.length * 0.1 }}
        style={{ display: "flex", 
          gap: "0.5rem",
          margin: "0 0 2px 2px"
         }}
      >
        <ButtonComponent
          buttonTitle="Save Theme"
          buttonText="Save Theme"
          onClick={() => {
            handleSubmit();
          }}
        />

        <ButtonComponent
          buttonTitle="Cancel"
          buttonText="Cancel"
          onClick={() => {
            handleFormVisibility();
          }}
        />
      </motion.div>
    </>
  );
}

export default CustomThemeForm;
